define("ember-composable-helpers/helpers/reduce", ["exports", "@ember/component/helper", "@ember/utils", "ember-composable-helpers/utils/as-array"], function (_exports, _helper, _utils, _asArray) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.reduce = reduce;
  function reduce(_ref) {
    let [callback, initialValue, array] = _ref;
    if ((0, _utils.isEmpty)(callback)) {
      return [];
    }
    return (0, _asArray.default)(array).reduce(callback, initialValue);
  }
  var _default = _exports.default = (0, _helper.helper)(reduce);
});